import { Notification } from "@mantine/core";

interface NotificationDisplayProps {
  notification: { title: string; message: string; color: string } | null;
  onClose: () => void;
}

export const NotificationDisplay = ({
  notification,
  onClose,
}: NotificationDisplayProps) => {
  if (!notification) return null;

  return (
    <>
      <Notification
        title={notification.title}
        color={notification.color}
        onClose={onClose}
        withCloseButton
      >
        {notification.message}
      </Notification>
      <br />
    </>
  );
};
